module.exports = __webpack_public_path__ + "static/media/wangyuheng.95835ca0.png";